import * as React from 'react';
import { type JSX } from 'react';

import confidoLogo from '../assets/icons/confido-logo-light.png';
import oddscheckerLogo from '../assets/icons/oc-us-logo-light.png';

const clickHandler =
  (url: string, fullPageUrl: string, analyticsDataLayer?: unknown[]) => (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (Array.isArray(analyticsDataLayer)) {
      analyticsDataLayer.push({
        action: 'Clickout - Powered by',
        category: 'Widget',
        event: 'powered_by_clickout',
        page: fullPageUrl,
        variation: 'grouped-offers',
      });
    }

    window.open(url, '_blank', 'noopener noreferrer');
  };

export const FOOTER_NOTICE_UK = (props: any) => (
  <svg fill="none" height={25} width={146} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      clipRule="evenodd"
      d="M33.962 12.58v2.787h2.168c.826.052 1.55-.517 1.601-1.342v-.05c0-.879-.723-1.448-1.807-1.448l-1.962.052Zm0-4.079v2.477h2.014c.722.052 1.393-.464 1.445-1.187v-.103c0-.672-.67-1.187-1.6-1.187h-1.859ZM31.07 6.85h3.924c1.756 0 2.375.05 2.892.257.98.465 1.55 1.395 1.55 2.48 0 1.031-.31 1.548-1.344 2.064 1.085.362 1.807 1.394 1.704 2.53 0 1.704-1.343 2.84-3.305 2.84h-5.42v-1.653h.774V8.5h-.775V6.85Zm15.334 5.368c0-.878-.723-1.549-1.549-1.549h-.052c-.877 0-1.6.671-1.754 1.497l3.355.052Zm1.962 2.271c-.36 1.705-1.755 2.737-3.614 2.737-2.168 0-3.769-1.703-3.769-4.078s1.601-4.079 3.77-4.079c1.186 0 2.323.568 2.994 1.6.516.878.826 1.86.774 2.892h-5.576c.206 2.013 1.497 2.116 1.858 2.116.723.052 1.395-.464 1.601-1.136l1.962-.052Zm6.454-2.528h3.563v5.06h-1.136v-1.6c-.213.36-.474.689-.775.98a3.62 3.62 0 0 1-2.322.877c-2.375 0-4.234-2.323-4.234-5.317 0-2.995 1.86-5.37 4.181-5.37 1.29-.05 2.428.672 3.047 1.756v-1.6h1.084v3.252h-1.136a3.395 3.395 0 0 0-.567-1.24c-.517-.67-1.343-1.083-2.17-1.135-1.238 0-3.097 1.084-3.097 4.233 0 2.48 1.341 4.286 3.097 4.286 1.395-.052 2.53-1.084 2.79-2.427.051-.258.051-.568.051-.826H54.77l.052-.93v.001Zm10.016 1.084-.723.104c-2.375.31-3.149.722-3.149 1.703a1.588 1.588 0 0 0 1.601 1.498c1.135-.052 2.117-.878 2.271-2.014v-1.29Zm2.221 4.027h-2.22v-1.394c-.517.98-1.55 1.55-2.634 1.55-1.29.102-2.427-.93-2.529-2.22v-.156c0-1.497 1.29-2.22 4.388-2.53l.723-.05v-.776c0-.878-.672-1.445-1.756-1.445s-1.652.36-1.858 1.393h-1.188a2.75 2.75 0 0 1 .878-1.6c.568-.465 1.342-.67 2.065-.67 1.6 0 2.943.722 2.943 2.684v4.285h1.084l.104.93Zm3.253-6.35c.36-.518 1.032-1.6 2.478-1.6 1.033 0 1.6.515 1.807 1.6.206-.36.413-.67.723-.98.465-.416 1.032-.673 1.652-.673 1.188 0 1.86.774 1.86 2.117v4.904h1.083v.93h-2.168V11.6c0-1.086-.362-1.602-1.136-1.602-1.343 0-2.066 1.601-2.066 2.168v3.924h1.136v.93h-2.27v-5.576c0-.98-.363-1.394-1.137-1.394-1.188 0-2.066 1.497-2.066 2.22v3.872h1.136v.93h-3.356v-.93h1.137v-5.989h-1.137v-.929h2.272l.052 1.496Zm12.96 3.045c0 1.291.98 2.323 2.22 2.427 1.342 0 2.167-1.188 2.167-3.098s-.877-3.046-2.168-3.046c-1.136 0-2.272 1.238-2.272 2.375l.052 1.342ZM81.1 6.383h2.17v4.492c.31-.568 1.186-1.704 2.528-1.704 1.756 0 3.098 1.807 3.098 4.08 0 2.116-1.445 3.923-3.098 3.923-1.393 0-2.065-.929-2.53-1.55v1.447h-2.22v-.93h1.085V7.313H81.1v-.93Zm8.46 0h2.22v9.76h1.031v.93h-3.304v-.93h1.136v-8.88H89.56v-.88Zm9.705 6.144c0-.723-.258-1.394-.774-1.962-.362-.309-.827-.516-1.29-.465a2.265 2.265 0 0 0-2.066 1.653c-.052.258-.155.516-.155.774h4.285Zm1.136 2.375c-.104.465-.31.826-.619 1.188a3.224 3.224 0 0 1-2.479 1.135c-2.117 0-3.614-1.65-3.614-4.026 0-2.273 1.497-4.027 3.408-4.027 1.91 0 3.459 1.497 3.459 4.233h-5.628c.104 1.136.361 1.808.878 2.323.413.362.93.57 1.445.57.878 0 1.446-.415 1.86-1.344l1.29-.052Zm6.144-6.143-1.343 4.543h2.685l-1.342-4.543Zm-1.239-1.91h2.477l2.84 8.57h.775v1.652h-2.324l-.671-2.22h-3.614l-.671 2.22h-2.375v-1.653h.775l2.788-8.569Zm5.988 2.426h3.099v1.497h-.775l1.084 4.595 1.291-6.092h2.013l1.291 5.988 1.033-4.49h-.774V9.274h3.097v1.497h-.671l-1.652 6.247h-2.065l-1.291-5.369-1.24 5.37h-2.065l-1.703-6.248h-.672V9.275Zm16.832 4.13c-1.808.155-2.995.31-2.995 1.395 0 .62.516 1.032 1.291 1.032.93 0 1.704-.723 1.756-1.653v-.774h-.052Zm1.858 2.17h.671v1.496h-2.426v-.93c-.568.723-1.446 1.084-2.374 1.084-1.55 0-2.738-1.032-2.738-2.425 0-2.273 2.582-2.53 5.061-2.737 0-1.187-.413-1.55-1.395-1.55-.98 0-1.342.465-1.393 1.188v.052l-1.86-.052c.104-1.55 1.343-2.53 3.201-2.53 2.169 0 3.305.98 3.305 2.737l-.052 3.666Zm4.333-5.062c.517-.98 1.084-1.394 1.962-1.394.309 0 .568.052.878.104v1.807c-.31-.052-.62-.104-.93-.104-.98-.05-1.806.672-1.858 1.601v2.995h.928v1.497h-3.613v-1.497h.775v-4.75h-.775V9.275h2.633v1.238Z"
      fill="#000"
      fillRule="evenodd"
    />
    <mask
      height={9}
      id="a"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
      width={9}
      x={137}
      y={9}
    >
      <path clipRule="evenodd" d="M137.57 9.068h7.543v8.157h-7.543V9.068Z" fill="#fff" fillRule="evenodd" />
    </mask>
    <g mask="url(#a)">
      <path
        clipRule="evenodd"
        d="M142.939 12.217c0-.878-.723-1.549-1.549-1.549h-.052c-.878 0-1.6.671-1.754 1.497l3.355.052Zm2.014 2.271c-.362 1.705-1.756 2.737-3.615 2.737-2.168 0-3.768-1.703-3.768-4.078s1.6-4.079 3.768-4.079c1.188 0 2.324.568 2.995 1.6.516.878.826 1.86.775 2.892h-5.576c.206 2.013 1.497 2.116 1.858 2.116.723.052 1.394-.464 1.601-1.136l1.962-.052Z"
        fill="#000"
        fillRule="evenodd"
      />
    </g>
    <mask
      height={25}
      id="b"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
      width={26}
      x={0}
      y={0}
    >
      <path clipRule="evenodd" d="M.99 0h24.478v24.477H.99V0Z" fill="#fff" fillRule="evenodd" />
    </mask>
    <g mask="url(#b)">
      <path
        clipRule="evenodd"
        d="M13.229 1.529C7.325 1.529 2.52 6.333 2.52 12.238c0 5.905 4.804 10.709 10.708 10.709 5.905 0 10.709-4.804 10.709-10.709 0-5.905-4.804-10.709-10.71-10.709h.002Zm0 22.948C6.479 24.477.99 18.987.99 12.238.99 5.489 6.48 0 13.229 0c6.75 0 12.239 5.489 12.239 12.238s-5.49 12.239-12.24 12.239h.001Z"
        fill="#000"
        fillRule="evenodd"
      />
    </g>
    <path
      clipRule="evenodd"
      d="M6.736 15.37v-4.316c-.303.064-.61.096-.92.096V9.966a2.537 2.537 0 0 0 1.48-.753h1.286v6.157H6.736Zm4.764-4.435c0 .361.214.608.654.608.44 0 .648-.219.648-.613 0-.41-.225-.643-.66-.643-.41 0-.642.2-.642.648Zm1.41 2.588c0-.51-.295-.756-.76-.756-.496 0-.753.288-.753.747 0 .491.31.773.768.773.466 0 .745-.267.745-.764Zm-3.338.057c0-.73.484-1.2.987-1.435-.494-.309-.753-.685-.753-1.283 0-.979.727-1.773 2.35-1.773 1.454 0 2.343.681 2.343 1.758 0 .705-.374 1.055-.775 1.246.436.175.993.643.993 1.45 0 1.196-.938 1.95-2.652 1.95-1.47 0-2.493-.744-2.493-1.913Zm9.308-3.377v1.925h1.87v1.308h-1.87v1.934h-1.336v-1.934h-1.902v-1.308h1.902v-1.925h1.336Z"
      fill="#000"
      fillRule="evenodd"
    />
  </svg>
);

export const FOOTER_NOTICE_US = '21+ Gambling Problem? Call 1-800-GAMBLER';

const POWERED_BY_US = ({
  analyticsDataLayer,
  fullPageUrl,
}: {
  analyticsDataLayer?: unknown[];
  fullPageUrl: string;
}) => (
  <>
    Powered by
    <a
      href="https://www.oddschecker.com/us/"
      onClick={clickHandler('https://www.oddschecker.com/us/', fullPageUrl, analyticsDataLayer)}
      rel="noopener noreferrer nofollow"
      target="_blank"
    >
      <img alt="oddschecker" height={20} src={oddscheckerLogo} width={108} />
    </a>
  </>
);

const POWERED_BY_UK = ({
  analyticsDataLayer,
  fullPageUrl,
}: {
  analyticsDataLayer?: unknown[];
  fullPageUrl: string;
}) => (
  <>
    Powered by
    <a
      href="https://www.oddschecker.com/"
      onClick={clickHandler('https://www.oddschecker.com/', fullPageUrl, analyticsDataLayer)}
      rel="noopener noreferrer nofollow"
      target="_blank"
    >
      <img alt="oddschecker" height={20} src={oddscheckerLogo} width={108} />
    </a>
  </>
);

const POWERED_BY_CONFIDO = ({
  analyticsDataLayer,
  fullPageUrl,
}: {
  analyticsDataLayer?: unknown[];
  fullPageUrl: string;
}) => (
  <>
    <p>Powered by </p>
    <a
      className="powered-by-confido"
      href="https://confidonetwork.com/"
      onClick={clickHandler('https://confidonetwork.com/', fullPageUrl, analyticsDataLayer)}
      rel="noopener noreferrer nofollow"
      target="_blank"
    >
      <img alt="confido" height="20" src={confidoLogo} width="90" />
    </a>
  </>
);

type PoweredByProps = {
  analyticsDataLayer?: unknown[];
  disableAnalytics: boolean;
  fullPageUrl: string;
  poweredBy?: string;
};

export const getPoweredBy = ({
  analyticsDataLayer,
  disableAnalytics,
  fullPageUrl,
  poweredBy,
}: PoweredByProps): JSX.Element | string => {
  if (!poweredBy) {
    return '';
  }

  const dataLayer = disableAnalytics ? [] : analyticsDataLayer;

  switch (poweredBy) {
    case 'us':
      return <POWERED_BY_US analyticsDataLayer={dataLayer} fullPageUrl={fullPageUrl} />;
    case 'uk':
      return <POWERED_BY_UK analyticsDataLayer={dataLayer} fullPageUrl={fullPageUrl} />;
    case 'confido':
      return <POWERED_BY_CONFIDO analyticsDataLayer={dataLayer} fullPageUrl={fullPageUrl} />;
    default:
      return '';
  }
};

export const getFooterNotice = (footerNotice: string | undefined): JSX.Element | string | null => {
  if (!footerNotice) {
    return null;
  }

  switch (footerNotice) {
    case 'uk':
      return <FOOTER_NOTICE_UK />;
    case 'us':
      return FOOTER_NOTICE_US;
    default:
      return footerNotice;
  }
};
